export default "__VITE_ASSET__980824c1__"